import { Box, Table, TableRow, TopBar } from '@sam/components';
import { useTranslation } from 'react-i18next';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { convertUserLanguagesIntoTableRows } from '../../utils/userLanguage/UserLanguage.utils';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useUser } from '../../components/UserContext';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const UserLanguageOverview: React.FC = () => {
  const { t } = useTranslation();
  const { axios, updateContextUser, user } = useUser();
  const navigate = useNavigate();
  const { data: loadedLanguages } = useData('USER_LANGUAGE_ALL', {
    config: { fallbackData: [] },
  });

  const rows: TableRow[] = useMemo(
    (): TableRow[] => convertUserLanguagesIntoTableRows(loadedLanguages, navigate),
    [loadedLanguages, navigate],
  );
  return (
    <>
      <TopBar title={t('pages.userLanguage.overview.topBarHeadline')}>
        <IconComponent type={IconType.ADD} onClick={() => navigate('/language/edit')} />
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.USER_LANGUAGE_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.USER_LANGUAGE_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={rows}
          header={
            t('pages.userLanguage.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  );
};
